"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Profiler_1 = require("icf-search-client-shared/lib/Profiler");
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var ListBase_1 = require("../ListBase");
var DomItemContainer_1 = require("./DomItemContainer");
var DomLayoutSite_1 = require("./DomLayoutSite");
var DomViewport_1 = require("./DomViewport");
var DomList = /** @class */ (function (_super) {
    __extends(DomList, _super);
    function DomList() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this._viewportRef = function (el) {
            _this._viewportElement = el;
        };
        _this._layoutSiteRef = function (el) {
            _this._layoutSiteElement = el;
        };
        return _this;
    }
    DomList.prototype.componentDidMount = function () {
        var _this = this;
        // jsdom event dispatching doesn't appear to work, so that blows...
        /* istanbul ignore next */
        this._visibilityChangeSubscription = (0, Utilities_1.subscribeToEvent)(document, function (ael) {
            return ael("visibilitychange", function () {
                if (document.visibilityState === "visible") {
                    _this.forceUpdate(null);
                }
            });
        });
        _super.prototype.componentDidMount.call(this);
    };
    DomList.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this._visibilityChangeSubscription.dispose();
    };
    DomList.prototype.renderList = function () {
        var _this = this;
        return Profiler_1.profiler.measure(function () {
            var contentSize = _this.isMounted ? _this.getFullContentSize() : null;
            var contentSizeStyle = contentSize
                ? {
                    width: contentSize.width,
                    height: contentSize.height,
                }
                : undefined;
            return ((0, jsx_runtime_1.jsx)("div", { ref: _this._viewportRef, children: (0, jsx_runtime_1.jsx)("div", { ref: _this._layoutSiteRef, style: contentSizeStyle, children: Array.from(_this.createItemContainers()) }) }));
        }, "DomList.render");
    };
    /* istanbul ignore next */
    DomList.prototype.createLayoutSite = function () {
        /* istanbul ignore next */
        return new DomLayoutSite_1.DomLayoutSite(this._layoutSiteElement);
    };
    /* istanbul ignore next */
    DomList.prototype.createViewport = function () {
        /* istanbul ignore next */
        return new DomViewport_1.DomViewport(this._viewportElement);
    };
    DomList.prototype.createItemContainer = function (item, itemIndex) {
        var key = this.props.itemToKey ? this.props.itemToKey(item) : null;
        var layoutRect = this.props.layout.getItemRectAtIndex(this.currentLayoutPassContext, itemIndex, item);
        return ((0, jsx_runtime_1.jsx)(DomItemContainer_1.DomItemContainer, { item: item, itemIndex: itemIndex, itemRenderer: this.props.itemRenderer, layoutRect: layoutRect }, key !== null ? key : itemIndex.toString()));
    };
    return DomList;
}(ListBase_1.ListBase));
exports.DomList = DomList;
//# sourceMappingURL=DomList.js.map